export const recommendation = () => {
    return {
        id: null,
        codigo: null,
        descripcion: null,
        id_estandar: null,
        id_tipo_recomendacion: null,
        worker_control: 0,
        company_control: 0
    };
};

export const params = () => {
    return {
        filter: null,
        per_page: 10,
        page: 1,
        standard_id: null
    };
};

export default {
    standards: [],
    recommendations: {
        data: []
    },
    recommendation: recommendation(),
    params: params(),
    editing: false,
    recommendation_types: [],
    modal: {
        show: false
    }
};
